import { ShowAlert } from "../../common/alert";
import copy from "./copy.svg";
import MedicalReport from "./markdownReaderCopyFeature";
import "./media.css";

const TemplateComp = ({ content }) => {
   const removeMarkdownSpecialCharacters = (markdownString) => {
      // Define a regular expression to match Markdown special characters
      const markdownRegex = /([*_~`]|^#{1,6}\s|^\[([^\]]+)\]\([^)]+\))/g;

      // Replace Markdown special characters with an empty string
      let cleanString = markdownString.replace(markdownRegex, "");
      cleanString = cleanString.replaceAll("###", "");

      return cleanString;
   };

   const copyContent = () => {
      const texttoCopy = isMarkdown(content) ? removeMarkdownSpecialCharacters(content) : content;
      navigator.clipboard
         .writeText(texttoCopy)
         .then(() => {
            ShowAlert("Copied to clipboard.");
         })
         .catch((error) => {
            ShowAlert("Error copying messages", "error");
         });
   };

   const isMarkdown = (text) => {
      // Check for common Markdown patterns
      const markdownPatterns = [
         /^#\s/, // Header
         /^\*\s|\d\.\s|\-\s/, // List
         /\[.*\]\(.*\)/, // Link
         // Add more patterns as needed
      ];

      for (const pattern of markdownPatterns) {
         if (pattern.test(text)) {
            return true;
         }
      }

      return false;
   };

   return (
      <>
         <div className="div-container-main mb-4">
            <div className="div-container-button ">
               <div className="header-text-view-notes">Playback Note </div>
               <button onClick={copyContent} className="button-copy">
                  <img src={copy} alt="copy-icon" className="copy-button-image" />{" "}
                  <div className="copy-action">Copy to Clipboard</div>
               </button>
            </div>

            <div className="scrole-width-view-notes-link no-scrollbar pt-2">
               {!isMarkdown(content) ? (
                  <pre
                     style={{
                        whiteSpace: "pre-wrap",
                        fontFamily: "inherit",
                        fontSize: "17px",
                     }}
                  >
                     {content}
                  </pre>
               ) : (
                  <MedicalReport content={content} />
               )}
            </div>
         </div>
      </>
   );
};

export default TemplateComp;
